import { render } from "./component-ogrn.vue?vue&type=template&id=7e96b830"
import script from "./component-ogrn.vue?vue&type=script&setup=true&lang=js"
export * from "./component-ogrn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-ogrn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e96b830"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e96b830', __exports__)) {
    api.reload('7e96b830', __exports__)
  }
  
  module.hot.accept("./component-ogrn.vue?vue&type=template&id=7e96b830", () => {
    api.rerender('7e96b830', render)
  })

}


export default __exports__